module.exports = __webpack_public_path__ + "img/40_13.b55e5d8a.png";